// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 711) return "711.cb82bf8ec6191d871f29.css";
	// return url for filenames based on template
	return "styles/" + "main" + "." + "9e8aa359f680f46523b1" + ".css";
};